import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Ana', 'Lucía', 'Roberto', 'Gabriela', 'Diego', 'Patricia', 'Fernando', 'Silvia'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setNotification({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      const nextDelay = Math.random() * 10000 + 10000;
      setTimeout(showNotification, nextDelay);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-3 left-3 z-50 max-w-[260px] animate-in slide-in-from-left duration-500" data-id="element-14">
      <div className="bg-[#141414] rounded-lg shadow-2xl shadow-green-900/30 border border-[#22c55e]/40 px-3 py-2.5 flex items-center gap-2.5" data-id="element-15">
        <div className="flex-shrink-0" data-id="element-16">
          <div className="h-8 w-8 bg-[#22c55e]/20 rounded-full flex items-center justify-center" data-id="element-17">
            <CheckCircle className="h-4 w-4 text-[#22c55e]" data-id="element-18" />
          </div>
        </div>
        <div className="min-w-0" data-id="element-19">
          <p className="text-[11px] font-medium text-white leading-tight" data-id="element-20">
            <span className="font-bold text-[#22c55e]" data-id="element-21">
              {notification.name}
            </span>{' '}
            de <span className="font-bold" data-id="element-22">{notification.city}</span>
          </p>
          <p className="text-[10px] text-gray-400 leading-tight mt-0.5" data-id="element-23">
            compró el Kit Completo
          </p>
          <p className="text-[9px] text-gray-500 mt-0.5" data-id="element-24">Hace unos instantes</p>
        </div>
      </div>
    </div>;
}